import { login, getPermission, logout } from '@/api/user'

const state = {
  token: localStorage.getItem('ats-token') || '',
  userInfo: JSON.parse(localStorage.getItem('ats-userInfo') || 'null'),
  permissions: JSON.parse(localStorage.getItem('ats-permissions') || '[]'),
  roles: JSON.parse(localStorage.getItem('ats-roles') || '[]')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('ats-token', token)
    } else {
      localStorage.removeItem('ats-token')
    }
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    if (userInfo) {
      localStorage.setItem('ats-userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('ats-userInfo')
    }
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
    if (permissions) {
      localStorage.setItem('ats-permissions', JSON.stringify(permissions))
    } else {
      localStorage.removeItem('ats-permissions')
    }
  },
  SET_ROLES(state, roles) {
    state.roles = roles
    if (roles) {
      localStorage.setItem('ats-roles', JSON.stringify(roles))
    } else {
      localStorage.removeItem('ats-roles')
    }
  }
}

const actions = {
  // 用户登录
  async login({ commit }, loginForm) {
    try {
      const token = await login(loginForm)
      commit('SET_TOKEN', token)
      return token
    } catch (error) {
      throw error
    }
  },

  // 获取用户权限信息
  async getPermission({ commit }) {
    try {
      const data = await getPermission()
      commit('SET_USER_INFO', {
        userId: data.userId,
        id: data.id || data.userId
      })
      commit('SET_PERMISSIONS', data.permissions || [])
      commit('SET_ROLES', data.roles || [])
      return data
    } catch (error) {
      throw error
    }
  },

  // 用户登出
  async logout({ commit }) {
    try {
      await logout()
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', null)
      commit('SET_PERMISSIONS', [])
      commit('SET_ROLES', [])
    } catch (error) {
      throw error
    }
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  permissions: state => state.permissions,
  roles: state => state.roles,
  // 检查是否有某个权限
  hasPermission: state => permissionName => {
    return state.permissions.some(p => p.permissionName === permissionName)
  },
  // 检查是否有某个角色
  hasRole: state => roleName => {
    return state.roles.some(r => r.roleName === roleName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
